import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
    BooleanFilterMenuComponent,
    DateFilterCellComponent,
    DateFilterMenuComponent,
    GridModule,
    NumericFilterCellComponent,
    NumericFilterMenuComponent,
    StringFilterCellComponent,
    StringFilterMenuComponent
} from '@progress/kendo-angular-grid';
import { DateInputModule, DateInputsModule, DateRangeModule } from '@progress/kendo-angular-dateinputs';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import '@progress/kendo-angular-intl/locales/nl/all'; // Load all required data for the NL locale
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ActionComponent } from './components/action/action.component';
import { ActionService } from './services/action.service';
import { BooleanComponent as BooleanFilterRowComponent } from './components/filters/row/boolean/boolean.component';
import { BooleanComponent } from './components/values/boolean/boolean.component';
import { DatatableComponent } from './components/datatable/datatable.component';
import { DateRangeComponent } from './components/filters/row/date-range/date-range.component';
import { FilterComponent } from './components/filter/filter.component';
import { FilterService } from './services/filter.service';
import { ImagesComponent } from './components/values/images/images.component';
import { LabelComponent } from './components/values/label/label.component';
import { MultiSelectComponent as MenuMultiSelectComponent } from './components/filters/menu/multi-select/multi-select.component';
import { MultiSelectComponent } from './components/filters/row/multi-select/multi-select.component';
import { NumericRangeComponent } from './components/filters/row/numeric-range/numeric-range.component';
import { ProgressComponent } from './components/values/progress/progress.component';
import { SelectComponent as MenuSelectComponent } from './components/filters/menu/select/select.component';
import { SelectComponent } from './components/filters/row/select/select.component';
import { StatePersistService } from './services/state-persist.service';
import { HttpClientModule } from '@angular/common/http';
import { ColumnChooserComponent } from './components/column-chooser/column-chooser.component';
import { TimeComponent } from './components/filters/menu/time/time.component';
import { TimeRangeComponent } from './components/filters/row/time-range/time-range.component';
import { ValueComponent } from './components/value/value.component';
import { ValueService } from './services/value.service';
import { ChassisLocalizationModule } from '@kaiser-software/chassis-localization';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        DropDownsModule,
        GridModule,
        NumericTextBoxModule,
        DateInputModule,
        DateInputsModule,
        DateRangeModule,
        BsDropdownModule.forRoot(),
        ProgressbarModule.forRoot(),
        ChassisLocalizationModule,
        HttpClientModule,
    ],
    declarations: [
        ActionComponent,
        BooleanComponent,
        BooleanFilterRowComponent,
        ColumnChooserComponent,
        DatatableComponent,
        DateRangeComponent,
        FilterComponent,
        ImagesComponent,
        LabelComponent,
        MenuMultiSelectComponent,
        MenuSelectComponent,
        MultiSelectComponent,
        NumericRangeComponent,
        ProgressComponent,
        SelectComponent,
        TimeComponent,
        TimeRangeComponent,
        ValueComponent,
    ],
    entryComponents: [
        ActionComponent,
        BooleanComponent,
        BooleanFilterRowComponent,
        DatatableComponent,
        DateRangeComponent,
        FilterComponent,
        ImagesComponent,
        LabelComponent,
        MenuMultiSelectComponent,
        MenuSelectComponent,
        MultiSelectComponent,
        NumericRangeComponent,
        ProgressComponent,
        SelectComponent,
        TimeComponent,
        TimeRangeComponent,
    ],
    exports: [
        ActionComponent,
        BooleanComponent,
        BooleanFilterRowComponent,
        ColumnChooserComponent,
        DatatableComponent,
        DateRangeComponent,
        FilterComponent,
        ImagesComponent,
        LabelComponent,
        MenuMultiSelectComponent,
        MenuSelectComponent,
        MultiSelectComponent,
        NumericRangeComponent,
        ProgressComponent,
        SelectComponent,
        TimeComponent,
        TimeRangeComponent,
        ValueComponent,
        ValueComponent,
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'nl'
        },
        StatePersistService,
    ]
})
export class ChassisDatatableModule {

    constructor(
        protected filterService: FilterService,
        protected valueService: ValueService,
    ) {
        this.filterService
            .register('text', {
                row: StringFilterCellComponent,
                menu: StringFilterMenuComponent
            })
            .register('numeric', {
                row: NumericFilterCellComponent,
                menu: NumericFilterMenuComponent
            })
            .register('numeric-range', {
                row: NumericRangeComponent,
                menu: NumericFilterMenuComponent
            })
            .register('boolean', {
                row: BooleanFilterRowComponent,
                menu: BooleanFilterMenuComponent
            })
            .register('date', {
                row: DateFilterCellComponent,
                menu: DateFilterMenuComponent
            })
            .register('date-range', {
                row: DateRangeComponent,
                menu: DateFilterMenuComponent
            })
            .register('time', {
                row: TimeRangeComponent,
                menu: TimeComponent
            })
            .register('select', {
                row: SelectComponent,
                menu: MenuSelectComponent
            })
            .register('multi-select', {
                row: MultiSelectComponent,
                menu: MenuMultiSelectComponent
            });

        this.valueService
            .register('label', LabelComponent)
            .register('progress', ProgressComponent)
            .register('images', ImagesComponent)
            .register('boolean', BooleanComponent);
    }

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ChassisDatatableModule,
            providers: [
                FilterService,
                ActionService,
                ValueService,
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/chassis-datatable.module.ts